function createPromiseWithResolvers() {
  let resolve;
  let reject;

  const promise = new Promise((nextResolve, nextReject) => {
    resolve = nextResolve;
    reject = nextReject;
  });

  return { promise, resolve, reject };
}

export function ensurePromiseWithResolvers() {
  if (typeof Promise.withResolvers !== 'function') {
    Promise.withResolvers = createPromiseWithResolvers;
  }
}
